import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Typography
} from '@mui/material';
import React from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {toggleCreatePODialog} from '../../store/slice/dialogSlice';
import {offRefreshButton, onRefreshButton} from '../../store/slice/buttonSlice';
import {showSuccessToast} from '../../constToast/constToast';
import {useNavigate} from "react-router-dom";
import {usePostCreateOrderFromBidsMutation} from "../../store/api/bidComparsion";

const CreatePODialog = () => {
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch(toggleCreatePODialog());
    };
    const [postCreateOrder] = usePostCreateOrderFromBidsMutation()
    const chartData = useSelector((state) => state.bidComparsionSlice.comparsionChartData)
    const open = useSelector(state => state.dialogSlice.createPODialog);
    const selectedBidComparsionGridData = useSelector((state) => state.bidComparsionSlice.selectedGridData)
    const navigate = useNavigate()


    const handleRefresh = () => {
        dispatch(onRefreshButton());
        setTimeout(() => {
            dispatch(offRefreshButton(false));
        }, 1);
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose} fullWidth>
                <DialogTitle>Create PO
                    for {selectedBidComparsionGridData[0]?.rfqNumber || selectedBidComparsionGridData[0]?.rfqNo}</DialogTitle>
                <Divider/>
                <DialogContent>
                    <DialogContentText>
                        <Typography component="span">
                            Are you sure, you want to create PO ?
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' onClick={async () => {
                        let data = await postCreateOrder({
                            bidMainIdList: chartData?.bids?.map(item => item?.bidMainId)
                        })
                        handleRefresh();
                        handleClose();
                        navigate('/bid-comparison')
                        if (data?.data?.statusCode === 200) {
                            showSuccessToast('Successfully')
                        }
                    }}>Create PO</Button>
                    <Button variant="outlined" onClick={handleClose}
                            sx={{color: 'gray', borderColor: '#D3D3D3'}}>Cancel</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default CreatePODialog;
